module.exports = __webpack_public_path__ + "static/bannerBlogDetail-6808025d01b64bf494ee05feff9ffac6.png";